import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';
import {
  ilustration_error,
  ilustration_error_resp,
} from '../../../../utils/images';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};
  `;
};

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const StepWrapper = styled.div`
  padding: 30px 0 62px 0;
`;

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 799px;
  width: 100%;
  height: 100vh;
`;

export const ResultBoxMessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  padding: 16px;
  gap: 30px;
  background: ${({ isSuccess }) =>
    isSuccess
      ? BaSeTheme.colors.feedbackInterface.sucesso20
      : BaSeTheme.colors.feedbackInterface.erro45};

  ${handleQuery(`
    margin: 0 20px 0 20px;
    align-items: flex-start;
  `)}
`;

export const ResultTextMessagetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  z-index: ${BaSeTheme.stackOrder.normal};
`;

export const ResultTextTitle = styled.div`
  font-size: 16px;

  ${handleQuery(`
    font-size: 13px;
  `)}
`;

export const ResultTextSubTitle = styled.div`
  font-size: 13px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${handleQuery(`
    font-size: 12px;
  `)}
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 60px;
`;

export const ImageResult = styled.div`
  background-repeat: no-repeat;
  width: 722px;
  height: 435px;

  ${handleQuery(`
    width: 375px;
    height: 448px;
  `)}

  ${({
    isSuccess,
    imgIlustrationError,
    imgIlustrationErrorResponsive,
    imgIlustrationSuccess,
    imgIlustrationSuccessResponsive,
  }) =>
    isSuccess
      ? css`
          background-image: url(${imgIlustrationSuccess});

          ${handleQuery(`
              background-image: url(${imgIlustrationSuccessResponsive});
          `)}
        `
      : css`
          background-image: url(${imgIlustrationError});

          ${handleQuery(`
              background-image: url(${imgIlustrationErrorResponsive});
          `)}
        `};
`;

export const ImageResultError = styled.div`
  background-image: url(${ilustration_error});
  background-repeat: no-repeat;
  width: 722px;
  height: 435px;

  ${handleQuery(`
      background-image: url(${ilustration_error_resp});
      width: 375px;
      height: 448px;
  `)}
`;

export const TextLink = styled.span`
  cursor: pointer;
  font-size: 16px;
  margin-top: 16px;
  text-decoration: underline;
  text-decoration-color: white;

  ${handleQuery(`
    font-size: 13px;
  `)}
`;
